import { Component } from '@angular/core';

@Component({
  selector: 'app-instagram-baner-shared',
  templateUrl: './instagram-baner-shared.component.html',
  styleUrls: ['./instagram-baner-shared.component.scss']
})
export class InstagramBanerSharedComponent {

  commentsCount = 0;
  likesCount = 0;
  followersCount = 0;
  maxCount = 1000;

  ngOnInit() {
    this.startCounting();
  }

  startCounting() {
    // افزایش تعداد کامنت‌ها
    setInterval(() => {
      this.commentsCount = (this.commentsCount + 1) % (this.maxCount + 1);
    }, 100000 / this.maxCount);

    // افزایش تعداد لایک‌ها
    setInterval(() => {
      this.likesCount = (this.likesCount + 1) % (this.maxCount + 1);
    }, 100000 / this.maxCount);

    // افزایش تعداد فالوورها
    setInterval(() => {
      this.followersCount = (this.followersCount + 1) % (this.maxCount + 1);
    }, 100000 / this.maxCount);
  }

}
